import { IconBus, IconCar, IconTrain } from 'components/icons';
import { cn } from 'lib/utils';
import React from 'react';

interface MapRoutesItemProps {
  transport: TransportItem;
  currentTab: TransportItem;
  setCurrentTab: (transport: TransportItem) => void;
}

interface TransportItem {
  value: string;
  label: string;
  icon: React.ReactNode;
  map: string;
}

export const MapRoutesItem = ({
  transport,
  currentTab,
  setCurrentTab,
}: MapRoutesItemProps) => {
  const handeClick = (transportItem: TransportItem) => {
    if (transportItem) {
      setCurrentTab(transportItem);
    }
  };

  return (
    <div
      onClick={() => handeClick(transport)}
      className={cn(
        'relative group pt-6 overflow-hidden h-[180px] rounded-b-[20px] cursor-pointer before:absolute before:top-0 before:left-0 before:right-0 before:transition-all before:h-1.5 before:w-full before:bg-plt-secondary group-hover:before:h-10',
        currentTab.value === transport.value && 'before:h-full'
      )}
    >
      <p
        className={cn(
          'relative z-10 font-semibold text-xl text-plt-black uppercase text-center',
          currentTab.value === transport.value && 'text-plt-white'
        )}
      >
        {transport.label}
      </p>
      <div className={cn('relative z-10 w-fit mx-auto mt-4')}>
        {transport.value === 'car' && (
          <div className='flex flex-col items-center'>
            <IconCar
              fillColor={
                currentTab.value === transport.value ? '#fff' : '#BB9056'
              }
            />
            <div className={cn(
              'relative z-10 font-semibold text-md mt-2 text-plt-black uppercase text-center',
              currentTab.value === transport.value && 'text-plt-white'
            )}>{transport.map}</div>
          </div>

        )}
        {transport.value === 'train' && (
          <div className='flex flex-col items-center'>
            <IconTrain
              fillColor={
                currentTab.value === transport.value ? '#fff' : '#BB9056'
              }
            />
            <div className={cn(
              'relative z-10 font-semibold text-md mt-2 text-plt-black uppercase text-center',
              currentTab.value === transport.value && 'text-plt-white'
            )}>{transport.map}</div>
          </div>

        )}
        {transport.value === 'bus' && (
          <IconBus
            fillColor={
              currentTab.value === transport.value ? '#fff' : '#BB9056'
            }
          />
        )}
      </div>
    </div>
  );
};
